/* eslint-disable max-lines-per-function */
import React, { useContext, useEffect, useState } from 'react';
import NoData from './noData';
import './dashboard.scss';
import { Menu, MenuItem } from '@mui/material';
import MultiSelectSearchDropdown from '../../../Components/MultiFilterSearch/multiFilterSearch';
import {
  fetchDepartmentList,
  fetchEmployeeList,
  fetchSkillList,
  filterSkillMap,
  fetchVertivalList,
} from '../apiCallUtil';
import {
  DOWNLOAD,
  SKILL_MAP_DASHBOARD,
  ADD_EDIT_RESPONSE_MESSAGES,
} from '../../../Constants/strings';
import ButtonComponent from '../../../Components/Button/button';
import ArrowDropDown from '../../../Assets/images/svg/drop-down-arrow.svg';
import pdfIcon from '../../../Assets/images/svg/pdf.svg';
import pdfhoverIcon from '../../../Assets/images/svg/pdf_hover.svg';
import excelIcon from '../../../Assets/images/svg/excel.svg';
import excelhoverIcon from '../../../Assets/images/svg/excel_hover.svg';
import FilteredListView from './filteredListView';
import ProfilePicPlaceHolder from '../../../Assets/images/png/profil-pic-placeholder-large.png';
import { AuthContext } from '../../../Contexts/AuthContext';
import {
  getSkillMappingDataPdf,
  getSkillMappingExcel,
} from '../../../Api/request/reportsFliter';
import SimpleSnackbar from '../../../Components/Snackbar/snackbar';
import { logError } from '../../../Utils/logger';
import { useNavigate } from 'react-router-dom';
import { MODULE_NAMES } from '../../../Constants/modules';
import SkillUploadDialog from '../../Skill/SkillUploadDialog';
import Loader from '../../../Components/Loader';
import UseAxios from '../../../Api/http/http';
import { uploadSkills } from '../../../Api/request/skills';
import { toast } from 'react-toastify';

const getResponsePayload = (response) => {
  if (response?.data?.isAxiosError) return response.data.response?.data || response.data;
  return response?.data || {};
};

const Dashboard = () => {
  const navigate = useNavigate();
  const [departmentList, setDepartmentList] = useState([]);
  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const [verticalList, setVerticalList] = useState([]);
  const [selectedVerticals, setSelectedVerticals] = useState([]);
  const [skillList, setSkillList] = useState([]);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [employeesList, setEmployeesList] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [activeLevel, setActiveLevel] = useState(null);
  const [levelFilteredList, setLevelFilteredList] = useState([]);
  const [noDataMessage, setNoDataMessage] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const [ispdfHovered, setIspdfHovered] = useState(false);
  const [isexcelHovered, setIsexcelHovered] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [severity, setSeverity] = useState('');
  const [uploadSkillOpen, setUploadSkillOpen] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const skillLevels = [1, 2, 3, 4];
  const { userProfile } = useContext(AuthContext);
  const configSkillPermission = userProfile?.permissions
    ? userProfile.permissions[MODULE_NAMES.CONFIGURATION_SKILL] || []
    : [];
  const masterSkillPermission = userProfile?.permissions
    ? userProfile.permissions[MODULE_NAMES.MASTER_TRAINING_SKILL] || []
    : [];

  const hasAccess = (action) => {
    return (
      configSkillPermission.includes(action)
      || masterSkillPermission.includes(action)
    );
  };

  useEffect(() => {
    fetchDepartmentList().then(setDepartmentList);
    fetchVertivalList().then(setVerticalList);
    fetchSkillList().then(setSkillList);
    fetchEmployeeList().then(setEmployeesList);
    clearFilter();
  }, []);

  useEffect(() => {
    if (
      selectedDepartments.length === 0
      && selectedVerticals.length === 0
      && selectedEmployees.length === 0
      && selectedSkills.length === 0
    ) {
      setFilteredList([]);
      setLevelFilteredList([]);
      setNoDataMessage('');
    } else {
      const data = {
        department: selectedDepartments,
        vertical: selectedVerticals,
        employee: selectedEmployees,
        skill: selectedSkills,
      };
      fetchFilteredSkillMap(data);
    }
  }, [selectedDepartments, selectedVerticals, selectedEmployees, selectedSkills]);

  const fetchFilteredSkillMap = async (data) => {
    try {
      const result = await filterSkillMap(data);
      if (result.skillMapDetails) {
        setFilteredList(result.skillMapDetails);
        setLevelFilteredList(result.skillMapDetails);
        setNoDataMessage('');
      } else if (result.noData) {
        setFilteredList([]);
        setLevelFilteredList([]);
        setNoDataMessage(result.noData);
      }
      setActiveLevel(null);
    } catch (error) {
      logError('Error fetching mapped skills:', error);
    }
  };

  const clearFilter = () => {
    setFilteredList([]);
    setLevelFilteredList([]);
  };

  const handleUploadSuccess = () => {
    fetchDepartmentList().then(setDepartmentList);
    fetchVertivalList().then(setVerticalList);
    fetchSkillList().then(setSkillList);
    fetchEmployeeList().then(setEmployeesList);
    if (
      selectedDepartments.length > 0
      || selectedVerticals.length > 0
      || selectedEmployees.length > 0
      || selectedSkills.length > 0
    ) {
      const data = {
        department: selectedDepartments,
        vertical: selectedVerticals,
        employee: selectedEmployees,
        skill: selectedSkills,
      };
      fetchFilteredSkillMap(data);
    }
  };

  const handleFileUpload = async (file) => {
    setIsUploading(true);
    try {
      const response = await UseAxios(uploadSkills(file));
      const payload = getResponsePayload(response);
      const failedRows = payload.failedRows || payload.summary?.failedRows;

      if (
        response?.data?.isAxiosError
        || response?.status >= 400
        || (failedRows && failedRows.length > 0)
      ) {
        let errorMsg = payload.message || 'Upload completed with errors.';
        if (failedRows && failedRows.length > 0 && !errorMsg.includes('Reasons:')) {
          const rowReasons = failedRows
            .slice(0, 4)
            .map((failedRow) => {
              const rowNum = failedRow.rowNumber || failedRow.row;
              const reason = failedRow.reason || 'Validation error';
              return `Row ${rowNum}: ${reason}`;
            })
            .join(' | ');
          const more = failedRows.length > 4 ? ` (+${failedRows.length - 4} more)` : '';
          errorMsg = `${errorMsg}: ${rowReasons}${more}`;
        }
        toast.error(errorMsg, { autoClose: 6000 });
        const summary = payload.summary;
        if (summary && (summary.processed > 0 || summary.created > 0 || summary.updated > 0)) {
          handleUploadSuccess();
        }
      } else {
        toast.success(payload.message || 'Skills uploaded successfully.');
        handleUploadSuccess();
      }
    } catch (error) {
      toast.error('Upload failed. Please check your connection.');
    } finally {
      setIsUploading(false);
    }
  };

  const handleDepartmentFilter = (event) => {
    setSelectedDepartments(event.target.value);
  };

  const handleVerticalFilter = (event) => {
    setSelectedVerticals(event.target.value);
  };

  const handleSkillFilter = (event) => {
    setSelectedSkills(event.target.value);
  };

  const handleEmployeeFilter = (event) => {
    setSelectedEmployees(event.target.value);
  };

  const calculateLevelCount = (level) => {
    const count = filteredList.filter(
      (item) => item.skillLevel === level,
    ).length;
    return count;
  };

  const filterListByLevel = (level) => {
    if (level === null) {
      setLevelFilteredList(filteredList);
    } else {
      const data = filteredList.filter((item) => item.skillLevel === level);
      setLevelFilteredList(data);
    }
  };

  const handleButtonClick = (level) => {
    setActiveLevel(level);
    filterListByLevel(level);
  };

  const displayEmployeeOption = (option) => (
    <div className="employee-options-display">
      <div className="profile-image-wrapper">
        <img
          src={option.photoSignedUrl || ProfilePicPlaceHolder}
          alt="Profile"
          className="profile-image"
          onError={(event) => {
            event.target.onerror = null; // Prevents infinite loop if placeholder image also fails
            event.target.src = ProfilePicPlaceHolder;
          }}
        />
      </div>
      {`${option.fullName} . ${option.employeeId}`}
    </div>
  );

  const handleDownloadClick = (event) => {
    // handle download reports
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    // handle close action on download reports
    setAnchorEl(null);
  };

  const handleDownloadPdf = async () => {
    const filters = {
      department: selectedDepartments.map((dept) => dept.name),
      vertical: selectedVerticals.map((vert) => vert.name),
      userId: selectedEmployees.map((emp) => emp.id),
      skillId: selectedSkills.map((skill) => skill.id),
      level: activeLevel,
    };
    try {
      if (
        (selectedDepartments.length === 0
          && selectedVerticals.length === 0
          && selectedEmployees.length === 0
          && selectedSkills.length === 0)
        || noDataMessage === 'No records found'
        || levelFilteredList.length === 0
      ) {
        snackbarOpen();
        setSnackbarMessage('No data to download');
        setSeverity('warning');
        return;
      }
      await getSkillMappingDataPdf(filters);
    } catch (error) {
      snackbarOpen();
      setSnackbarMessage(ADD_EDIT_RESPONSE_MESSAGES.OOPS_TRY_AGAIN);
      setSeverity('warning');
    } finally {
      handleCloseMenu();
    }
  };

  const handleDownloadExcel = async () => {
    const filters = {
      department: selectedDepartments.map((dept) => dept.name),
      vertical: selectedVerticals.map((vert) => vert.name),
      userId: selectedEmployees.map((emp) => emp.id),
      skillId: selectedSkills.map((skill) => skill.id),
      level: activeLevel,
    };
    try {
      if (
        (selectedDepartments.length === 0
          && selectedVerticals.length === 0
          && selectedEmployees.length === 0
          && selectedSkills.length === 0)
        || noDataMessage === 'No records found'
        || levelFilteredList.length === 0
      ) {
        snackbarOpen();
        setSnackbarMessage('No data to download');
        setSeverity('warning');
        return;
      }
      await getSkillMappingExcel(filters);
    } catch (error) {
      snackbarOpen();
      setSnackbarMessage(ADD_EDIT_RESPONSE_MESSAGES.OOPS_TRY_AGAIN);
      setSeverity('warning');
    } finally {
      handleCloseMenu();
    }
  };

  const snackbarOpen = () => {
    setOpenSnackbar(true);
    setTimeout(() => {
      setOpenSnackbar(false);
    }, 4000);
  };
  const renderDepartmentDropdown = () => {
    return (
      <MultiSelectSearchDropdown
        dropdownCss="search-department"
        options={departmentList}
        value={selectedDepartments}
        onChange={handleDepartmentFilter}
        placeholder={SKILL_MAP_DASHBOARD.SEARCH_FILTER_TEXT.DEPARTMENT}
        autoFocus={true}
        size="small"
        id="search-department"
        SearchPlaceHolder={SKILL_MAP_DASHBOARD.SEARCH_PLACEHOLDER.DEPARTMENT}
      />
    );
  };

  const renderVerticalDropdown = () => {
    return (
      <MultiSelectSearchDropdown
        dropdownCss="search-vertical"
        options={verticalList}
        value={selectedVerticals}
        onChange={handleVerticalFilter}
        placeholder={SKILL_MAP_DASHBOARD.SEARCH_FILTER_TEXT.VERTICAL}
        autoFocus={true}
        size="small"
        id="search-vertical"
        SearchPlaceHolder={SKILL_MAP_DASHBOARD.SEARCH_PLACEHOLDER.VERTICAL}
      />
    );
  };

  const handleSnackbar = (message, significance) => {
    setOpenSnackbar(true);
    setSnackbarMessage(message);
    setSeverity(significance);
    setTimeout(() => {
      setOpenSnackbar(false);
    }, 4000);
  };

  return (
    <div className="skill-map-list-dashboard">
      {isUploading && (
        <div className="loader" role="status" aria-live="polite">
          <Loader text="Uploading skills..." />
        </div>
      )}
      <div className="search-container">
        <div className="autocomplete-container">
          <div className="search-employee-container">
            <MultiSelectSearchDropdown
              dropdownCss="search-employee"
              options={employeesList}
              value={selectedEmployees}
              onChange={handleEmployeeFilter}
              placeholder={SKILL_MAP_DASHBOARD.SEARCH_FILTER_TEXT.EMPLOYEE}
              autoFocus={true}
              size="small"
              id="search-skill"
              SearchPlaceHolder={
                SKILL_MAP_DASHBOARD.SEARCH_PLACEHOLDER.EMPLOYEE
              }
              displayOption={displayEmployeeOption}
            />
          </div>

          <div className="search-skill-container">
            <MultiSelectSearchDropdown
              dropdownCss="search-skill"
              options={skillList}
              value={selectedSkills}
              onChange={handleSkillFilter}
              placeholder={SKILL_MAP_DASHBOARD.SEARCH_FILTER_TEXT.SKILL}
              autoFocus={true}
              size="small"
              id="search-skill"
              SearchPlaceHolder={SKILL_MAP_DASHBOARD.SEARCH_PLACEHOLDER.SKILL}
            />
          </div>

          <div className="search-vertical-container">
            {renderVerticalDropdown()}
          </div>
          <div className="search-department-container">
            {renderDepartmentDropdown()}
          </div>
        </div>

        <div className="button-container skill-map-button">
          <div className="div-left">{renderVerticalDropdown()}</div>
          <div className="div-left">{renderDepartmentDropdown()}</div>
          <div className="div-right">
            <div className="skill-map-button-download">
              <ButtonComponent
                label={DOWNLOAD}
                variant="text"
                onClick={handleDownloadClick}
                endIcon={<img src={ArrowDropDown} alt="Dropdown Arrow" />}
                btnCss='download-skill-map-btn'
              ></ButtonComponent>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleCloseMenu}
              >
                <MenuItem
                  onClick={handleDownloadPdf}
                  className="download-skill-map-dropdown"
                  onMouseEnter={() => setIspdfHovered(true)}
                  onMouseLeave={() => setIspdfHovered(false)}
                >
                  <img
                    src={ispdfHovered ? pdfhoverIcon : pdfIcon}
                    style={{ marginRight: 8 }}
                    alt="PDF Icon"
                  />{' '}
                  Download as PDF
                </MenuItem>
                <MenuItem
                  onClick={handleDownloadExcel}
                  className="download-skill-map-dropdown"
                  onMouseEnter={() => setIsexcelHovered(true)}
                  onMouseLeave={() => setIsexcelHovered(false)}
                >
                  <img
                    src={isexcelHovered ? excelhoverIcon : excelIcon}
                    style={{ marginRight: 8 }}
                    alt="excel Icon"
                  />{' '}
                  Download as Excel
                </MenuItem>
              </Menu>
            </div>
            <div className="skill-map-button-upload">
              <ButtonComponent
                disabled={!hasAccess('create')}
                label="Upload"
                variant="outlined"
                onClick={() => setUploadSkillOpen(true)}
                btnCss={
                  !hasAccess('create')
                    ? 'upload-skill-btn-disabled'
                    : 'upload-skill-btn'
                }
              />
            </div>
            <div>
              <ButtonComponent
                disabled={!hasAccess('create')}
                label={SKILL_MAP_DASHBOARD.ADD.BUTTON_TEXT}
                variant="contained"
                onClick={() => {
                  navigate('/skills/map');
                }}
                btnCss={
                  !hasAccess('create')
                    ? 'add-skill-btn-disabled'
                    : 'add-skill-btn'
                }
              ></ButtonComponent>
            </div>
          </div>
        </div>
      </div>

      <div className="level-filter-container">
        <div className="level-filters">
          <button
            id={'skill-map-level-all'}
            className={`skill-level-filter-button all  ${
              activeLevel === null && levelFilteredList.length > 0
                ? 'active'
                : ''
            }`}
            onClick={() => handleButtonClick(null)}
          >
            All ({filteredList.length})
          </button>
          {skillLevels.map((level) => (
            <button
              key={level}
              id={`skill-map-level-${level}`}
              className={`skill-level-filter-button ${
                activeLevel === level
                  ? 'active'
                  : ''
              }`}
              onClick={() => handleButtonClick(level)}
            >
              Level {level} ({calculateLevelCount(level)})
            </button>
          ))}
        </div>
      </div>

      {filteredList.length > 0 && (
        <FilteredListView
          filteredValues={levelFilteredList}
          setFilteredList={setFilteredList}
          setLevelFilteredList={setLevelFilteredList}
          handleSnackbar={handleSnackbar}
          activeLevel={activeLevel}
        />
      )}

      {filteredList.length === 0 && (
        <NoData
          message={noDataMessage || SKILL_MAP_DASHBOARD.NO_DATA_TEXT}
          displayImage={!noDataMessage}
        />
      )}
      <SimpleSnackbar
        open={openSnackbar}
        message={snackbarMessage}
        severity={severity}
      />
      {uploadSkillOpen && (
        <SkillUploadDialog
          open={uploadSkillOpen}
          onClose={() => setUploadSkillOpen(false)}
          onUpload={handleFileUpload}
          onSuccess={handleUploadSuccess}
        />
      )}
    </div>
  );
};

export default Dashboard;
